module.exports = __webpack_public_path__ + "media/buy_report_icons/services-a25f7fd5.svg";